import cn from 'classnames';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import formatNumber from '@framework/data-helpers/formatters/formatNumber';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';
import { ISize } from '@/creditflowresearch/domain/vo/League/IStandings';
import { ISelectedPeriod } from '@/creditflowresearch/application/League/interfaces';

import standingStyles from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/standingTable.module.scss';

interface IProps {
  row: {
    hasAmount: boolean,
    isSelected: boolean,
    count: number,
    size: ISize,
    categoryId: string,
    dateFrom: string,
    dateTo: string,
  },
  rowIndex: string,
}

const CellContent = ({
  row,
  rowIndex,
}: IProps) => {
  const { selectPeriod } = useScorecardContext();

  const cellStyle = cn(
    standingStyles.cell,
    {
      [standingStyles.withoutAmount]: !row.hasAmount,
    },
  );

  const wrapperCellStyle = cn(
    standingStyles.wrapperCell,
    {
      [standingStyles.selectedCell]: row.isSelected,
      [standingStyles.emptyCell]: !row.count,
    },
  );

  const onClick = () => {
    if (!row?.categoryId || !row?.count) {
      return;
    }
    selectPeriod(row as unknown as ISelectedPeriod);
  };

  let size = '-';

  if (row.size) {
    size = formatNumber(row.size.size, {
      symbolOnLeft: true,
      symbol: row.size.displayName,
      spaceBetweenValueAndSymbol: true,
    });
  }

  return (
    <span className={ cellStyle } onClick={ onClick }>
      <Tooltip
        content="Show deals"
        disabled={ row.isSelected || !row.count || rowIndex === 'tfoot' }
      >
        <span className={ wrapperCellStyle }>
          <span className={ standingStyles.countCell }>
            { row.count || '-' }
          </span>
          { row.hasAmount && (
            <span className={ standingStyles.amountCell }>{ size }</span>
          ) }
        </span>
      </Tooltip>
    </span>
  );
};

export default CellContent;
